import React, {useContext, useEffect, useState} from 'react';
import './ChatList.css'
import {observer} from "mobx-react-lite";
import ModalAddChatUser from "../Modal/ModalAddChatUser";
import {fetchUsers} from "../../http/UserAPI";
import {FriendContext} from "../../App";
import {Context} from "../../index";

const ChatList = () => {

    const {
        friendList,
        setFriendList,
        oneFriend,
        setOneFriend,
        messages,
        setOneChatId,
        onlineUsers
    } = useContext(FriendContext)
    const {userStore} = useContext(Context)

    const [acshow, setAcshow] = useState(false)
    const [allUsers, setAllUsers] = useState([])
    const [executor, setExecutor] = useState('')


    useEffect(() => {
        fetchUsers().then(data => setAllUsers(data))
    }, [])


    let chatUser = friendList.filter(i => i.firstSocketId === userStore.user.socketId || i.secondSocketId === userStore.user.socketId)
        .reduce((op, cur) => {
            if (cur.firstSocketId === userStore.user.socketId) op.push({id: cur.id, firstSocketId: cur.secondSocketId});
            else op.push({id: cur.id, firstSocketId: cur.firstSocketId});
            return op;
        }, [])

    const friendListUser = chatUser.map(item => {
        const userWithList = allUsers.filter(usr => usr['socketId'] === item['firstSocketId'])
        const userChatList = userWithList.reduce((acc, curr) => {
            acc.push(curr)
            return acc
        }, [])
        const msgWithList = messages.filter(msg => msg['chatId'] === item['id'])
        const msgChatList = msgWithList.reduce((acc, curr) => {
            acc.push(curr)
            return acc
        }, [])
        return {...item, user: userChatList, message: msgChatList}
    })


    const noReadMsgChat = (friend) => {
        return messages.filter(i => i.firstSocketId === friend && i.secondSocketId === userStore.user.socketId && i.isRead === false)
    }

    const setOneFriendsAndChatId = (firstSocketId, chatId) => {
        setOneFriend(firstSocketId)
        setOneChatId(chatId)
    }

    const getOnlineUserStatus = (firstSocketId) => {
        return onlineUsers.includes(firstSocketId)
            ? <div className="online">Online</div>
            : <div className="offline">Offline</div>
    }


    const urlTasks = /(task)/;

    return (
        <>
            <div className="chat__list__block">
                <div className="add__list__block">
                    <button className="add__list__btn" onClick={() => setAcshow(true)}>+ Добавить чат</button>
                </div>

                <div className="chat__user__block">

                    {friendListUser.length === 0
                        ?
                        <div className="no__chat">У вас пока нет открытых чатов</div>
                        :
                        <>
                            {friendListUser
                                .sort((a, b) => (b.message.at(-1).createdAt < a.message.at(-1).createdAt) ? -1 : ((b.message.at(-1).createdAt > a.message.at(-1).createdAt) ? 1 : 0))
                                .map(friend =>
                                    <>
                                        {friend.user.map(i =>
                                            <div
                                                key={i.id}
                                                className={
                                                    friend.firstSocketId === oneFriend
                                                        ?
                                                        "chat__one__user__active"
                                                        :
                                                        "chat__one__user"
                                                }
                                                onClick={() => setOneFriendsAndChatId(friend.firstSocketId, friend.id)}
                                            >
                                                <div className="online__block">

                                                    {getOnlineUserStatus(friend.firstSocketId)}

                                                    <div className="name__and__msg">
                                                        <div className="chat__name">{i.firstName} {i.secondName}</div>
                                                        {friend.message
                                                            .sort(({id: previoudID}, {id: currentID}) => previoudID - currentID)
                                                            .reverse()
                                                            .slice(0, 1)
                                                            .map((msg) => {
                                                                    msg.message.split(urlTasks)
                                                                    if (msg.message.match(urlTasks)) {
                                                                        return <div
                                                                            key={msg.id}
                                                                            className="chat__msg">
                                                                            "Задача №{msg.message.replace('task/', '')}"
                                                                        </div>
                                                                    } else {
                                                                        return <div
                                                                            key={msg.id}
                                                                            className="chat__msg">
                                                                            "{msg.message}"
                                                                        </div>
                                                                    }
                                                                }
                                                            )


                                                        }

                                                    </div>
                                                    {noReadMsgChat(friend.firstSocketId).length === 0
                                                        ? null
                                                        :
                                                        <div className="msg__lenght">
                                                            <div>{noReadMsgChat(friend.firstSocketId).length}</div>
                                                        </div>
                                                    }

                                                </div>

                                            </div>
                                        )}
                                    </>
                                )}
                        </>
                    }

                </div>
            </div>


            {/*mobile version*/}

            <div className="chat__list__mobile__all__block">
                <div className="chat__list__mobile__block"
                     style={{display: oneFriend.length === undefined ? "block" : "none"}}>
                    <div className="add__list__block">
                        <button className="add__list__btn" onClick={() => setAcshow(true)}>+ Добавить чат</button>
                    </div>

                    <div className="chat__user__block">

                        {friendList.length === 0
                            ?
                            <div className="no__chat">У вас пока нет открытых чатов</div>
                            :
                            <>
                                {friendListUser
                                    .map(friend =>
                                        <>
                                            {friend.user.map(i =>
                                                <div
                                                    key={i.id}
                                                    className={
                                                        friend.firstSocketId === oneFriend
                                                            ?
                                                            "chat__one__user__active"
                                                            :
                                                            "chat__one__user"
                                                    }
                                                    onClick={() => setOneFriendsAndChatId(friend.firstSocketId, friend.id)}
                                                >
                                                    <div className="online__block">

                                                        {getOnlineUserStatus(friend.firstSocketId)}

                                                        <div className="name__and__msg">
                                                            <div
                                                                className="chat__name">{i.firstName} {i.secondName}</div>
                                                            {friend.message
                                                                .sort(({id: previoudID}, {id: currentID}) => previoudID - currentID)
                                                                .reverse()
                                                                .slice(0, 1)
                                                                .map((msg) => {
                                                                        msg.message.split(urlTasks)
                                                                        if (msg.message.match(urlTasks)) {
                                                                            return <div
                                                                                key={msg.id}
                                                                                className="chat__msg">
                                                                                "Задача №{msg.message.replace('task/', '')}"
                                                                            </div>
                                                                        } else {
                                                                            return <div
                                                                                key={msg.id}
                                                                                className="chat__msg">
                                                                                "{msg.message}"
                                                                            </div>
                                                                        }
                                                                    }
                                                                )


                                                            }

                                                        </div>
                                                        {noReadMsgChat(friend.firstSocketId).length === 0
                                                            ? null
                                                            :
                                                            <div className="msg__lenght">
                                                                <div>{noReadMsgChat(friend.firstSocketId).length}</div>
                                                            </div>
                                                        }
                                                    </div>

                                                </div>
                                            )}
                                        </>
                                    )}
                            </>
                        }

                    </div>

                </div>
            </div>
            <ModalAddChatUser acshow={acshow} setAcshow={setAcshow} allUsers={allUsers} setExecutor={setExecutor}
                              executor={executor} setFriendList={setFriendList}/>
        </>
    );
};

export default observer(ChatList);